<template>
  <v-main>
    <BaseCrudTable ref="basetable"
                   :headers="headers"
                   :keep-data-fields="['diseasetype']"
                   @editClicked="editClick"
                   table-name="Тесты"
                   endpoint="tests"
                   label="Тесты"
                   group-by="report_type_group">
      <template v-slot:editVals>
        <v-col>
          <div ref="form">
            <v-card-text>
              <v-text-field
                ref="name"
                v-model="editItem.name"
                :rules="[() => !!editItem.name || 'Поле обязательно']"
                :error-messages="errorMessages"
                label="Имя"
                placeholder="Название теста"
                required />
            </v-card-text>
            <v-card-text>
              <v-select
                ref="diseasetype"
                v-model="editItem.diseasetype"
                :items="diseaseTypes"
                :rules="[() => !!editItem.diseasetype || 'Поле обязательно']"
                :error-messages="errorMessages"
                item-text="name"
                item-value="id"
                label="Выберите заболевание"
                required />
            </v-card-text>
            <v-card-text>
              <BaseAutoComplete ref="report_type"
                                v-model="editItem.report_type"
                                :items="reportTypeItems"
                                :rules="[() => !!editItem.report_type || 'Поле обязательно']"
                                :value="reportTypeSelected"
                                :error-messages="errorMessages"
                                @updateSelected="updateReportTypes"
                                label="Доступные отчеты"
                                required />
            </v-card-text>
            <v-card-text>
              <v-select ref="report_availability"
                        v-model="editItem.report_availability"
                        :items="reportAvailabilityItems"
                        :error-messages="errorMessages"
                        item-text="name"
                        item-value="id"
                        label="Видимость"
                        required />
            </v-card-text>
            <v-card-actions>
              <v-btn @click="close()" text>
                Отмена
              </v-btn>
              <v-spacer />
              <v-slide-x-reverse-transition>
                <v-tooltip
                  v-if="formHasErrors"
                  left />
              </v-slide-x-reverse-transition>
              <v-btn @click="submit" color="primary" text>
                Подтвердить
              </v-btn>
            </v-card-actions>
          </div>
        </v-col>
      </template>
    </BaseCrudTable>
  </v-main>
</template>

<script>
import BaseCrudTable from '../base/BaseCrudTable'
import BaseAutoComplete from '../base/BaseAutoComplete'
import {mapState} from 'vuex'

export default {
  name: "TestsTable",
  components: {BaseCrudTable, BaseAutoComplete},
  data () {
    return {
      headers: [
        {text: '', value: 'importance', align: 'left'},
        {text: 'id', value: 'id', align:  'd-none', class:['d-none']},
        {text: 'Название', value: 'name', align: 'left'},
        {text: 'Заболевание', value: 'diseasetype', align: 'left'},
        // {text: 'Классификатор', value: 'classificator', align: 'left'},
        {text: 'Отчет', value: 'report_type', align: 'd-none',class: ['d-none']},
        {text: 'Отчет', value: 'report_type_group', align: 'left'},
        {text: 'Видимость', value: 'report_availability', align: 'left'},
        {text: 'Действия', value: '', align: 'left'}
      ],
      editItem: {
        name: '',
        report_type: [{'id':'case','name':'КМ'}],
        report_availability: '',
        id: ''
      },
      reportTypeSelected: [],
      dialog: false,
      errorMessages: '',
      formHasErrors: false,
    }
  },
   computed: {
    form () {
      return {
        name: this.editItem.name,
        report_type: this.editItem.report_type
      }
    },
    ...mapState({
      diseaseTypes: state => state.tableData.diseaseTypes,
      // classificators: state => state.tableData.classificators
    })
  },
  methods: {
    editClick (newVal) {
      this.simpleEditClick(newVal)
    },
    updateReportTypes (newVal) {
      this.editItem.report_type = newVal
      this.reportTypeSelected = newVal
    },
    submit () {
      this.formSubmit()

    },
    close () {
      this.$refs["basetable"].close()
    }
  }


}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/tables/TestsTable.vue